import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./AMCNew.css";
import { trackEvent, trackPageView } from "../../utils/tracking";

function Values() {
  useEffect(() => {
    trackPageView(
      "https://www.jmfinancialmf.com/AboutUs/AMC",
      "jmf_about-us_amc"
    );
    // trackPageView("http://localhost:710/AboutUs", "jmf_about-us");

    trackEvent({
      category: "Dynamic Page",
      action: "AMC Page Loaded",
      label: "jmf_about-us_amc",
      // value: 1,
    });
  }, []);
  return (
    <>
      <section>
        <Container>
          <div className="vision-main">
            <div className="section-header">
              <h2>JM Financial Asset Management Ltd.(AMC)</h2>
            </div>
            <div className="vision-detail">
              <Row>
                <Col sm={12} md={12}>
                  <div className="vision-data">
                    <p>
                   
                        JM Financial Asset Management Ltd. represents the Mutual Fund business of the JM Financial Ltd Group. It commenced operations in 1994 and is one of the oldest private sector mutual funds in the country. Our strength lies in our growing family of over 29,500+ partners, who work with us across India, covering multiple locations. JM Financial Mutual Fund offers a range products spanning the entire risk-return spectrum, to lakhs of investors, both institutional and individual. The Assets under Management of JM Financial Mutual Fund stands at around ₹ 12,000.03 /- Crores as of 31 Mar 2026.
                    </p>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
}

export default Values;
